
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
      loading: false,
        data: {},
        tenants: {},

       error: false,
        lastFetched: null,
};
// Try to load from localStorage
// const saved = localStorage.getItem('tenants_');
// if (saved) {
//     try {
//         const parsed = JSON.parse(saved);
//         initialState.tenants = parsed.tenants || {};
//         initialState.lastFetched = parsed.lastFetched || null;
//     } catch (err) {
//         console.error('Error parsing localStorage home cache:', err);
//     }
// }

export const siteDashboardSlice = createSlice({
    name: 'siteDashboard',
    initialState: initialState,
    reducers: {
        SITE_DASHBOARD_FETCH_START: (state) => {
           
            state.loading = true;
            state.error = false;
            // Optional: Reset only that site's data if needed
            // state.data[siteId] = null;
        },
        SITE_DASHBOARD_FETCH_SUCCESS: (state, action) => {
            const { siteId, payload } = action.payload;
            state.loading = false;
            state.data[siteId] = payload;
            state.tenants[siteId] = payload.dc_energy_meter;
               // ✅ Save to localStorage
            localStorage.setItem(`tenants_${siteId}`, JSON.stringify({
                tenants: payload.dc_energy_meter,
                lastFetched: Date.now()
            }));
        },
        SITE_DASHBOARD_FETCH_ERROR: (state) => {
            state.loading = false;
            state.error = true;
        }
    }
});

export const { SITE_DASHBOARD_FETCH_START, SITE_DASHBOARD_FETCH_ERROR, SITE_DASHBOARD_FETCH_SUCCESS } = siteDashboardSlice.actions;
export default siteDashboardSlice.reducer;